import Input from "../Input/Input";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Checkbox extends Input {
    constructor(dom, options) {
        super(dom, "Checkbox");

        console.log (options);
        /*this.type = this.domNode.getAttribute("type") ? this.domNode.getAttribute("type") : "text";

        this.options = options ? options : {};

        this._configByType();*/
    }

}

window.Checkbox = Checkbox;